/* eslint:disable variable-name */

import map from "lodash/map";
import { ContentFormatV2 } from "../v2/content_format";
import { TemplateFormatV2 } from "../v2/template_format";
import { ContentFormatV1 } from "./content_format";
import { TemplateFormatV1 } from "./template_format";

export function upgradeContentToV2(contentFormat: ContentFormatV1): ContentFormatV2 {
  return { ...contentFormat, definition_version: 2 };
}

export function upgradeTemplateToV2(templateFormat: TemplateFormatV1): TemplateFormatV2 {
  return {
    ...templateFormat,

    definition_version: 2,

    asset_definitions: map(templateFormat.asset_definitions, (asset_definition) => ({
      asset_id: asset_definition.asset_id,
      key: asset_definition.key,
    })),

    option_definitions: [],

    page_definitions: map(templateFormat.page_definitions, (page_definition) => ({
      ...page_definition,

      presentations: [],
    })),

    presentation_definitions: [],
  };
}
